import { StackNavigationProp, createStackNavigator } from "@react-navigation/stack";
import React from "react";

import Cart from "@/screens/Cart";
import Product from "@/screens/Product";

export type CartStackParamList = {
  cart: undefined;
  product: {
    productId: string;
  };
};

export const CartRoutePaths = {
  cart: "/carrinho",
  product: "/carrinho/produto",
};

export type CartNavigation = StackNavigationProp<CartStackParamList>;

const CartStackNav = createStackNavigator<CartStackParamList>();

const CartStack = () => {
  return (
    <CartStackNav.Navigator
      initialRouteName="cart"
      screenOptions={{ headerShown: false, headerMode: "screen" }}>
      <CartStackNav.Screen name="cart" component={Cart} options={{ title: "Carrinho" }} />
      <CartStackNav.Screen name="product" component={Product} options={{ title: "Produto" }} />
    </CartStackNav.Navigator>
  );
};

export default CartStack;
